export default class CompletionLockerNote {

  constructor(data) {
    const template = {
      id: 0,
      completionRecordId: "",
      containerId: "",
      memberId: "",
      memberName: "",
      timestamp: null,
      notes: ""
    };

    // TODO: add validation for mandatory items
    if (data) {
      this.data = data;
    } else {
      this.data = template;
    }
  }

  toJson = () => {
    return JSON.stringify(this.data);
  }

  getId = () => {
      return this.data.id;
  }

  setId = (value) => {
    this.data.id = value;
  }

  getCompletionRecordId = () => {
    return this.data.completionRecordId;
  }

  setCompletionRecordId = (value) => {
    this.data.completionRecordId = value;
  }

  getContainerId = () => {
    return this.data.containerId;
  }

  setContainerId = (value) => {
    this.data.containerId = value;
  }

  getMemberId = () => {
    return this.data.memberId;
  }

  setMemberId = (value) => {
    this.data.memberId = value;
  }

  getTimestamp = () => {
    return this.data.timestamp;
  }

  setTimestamp = (value) => {
    this.data.timestamp = value;
  } 

  getNotes = () => {
    return this.data.notes;
  }

  setNotes = (value) => {
    this.data.notes = value;
  }
}